import {combineReducers} from 'redux';

// @ts-expect-error
import {ActionTypes, AppAction} from './app-actions';

/*
 * Changes to this number indicate a breaking change in our API, requiring a refresh of the page before
 * further requests can be made.
 */
type ApiVersionState = AppState['apiVersion'];
const apiVersionReducer = (
    state: ApiVersionState | null | undefined = null,
    action: AppAction
): ApiVersionState => {
    switch (action.type) {
        case ActionTypes.APP_SET_API_VERSION:
            return action.payload;
        default:
            return state;
    }
};

/*
 * Here is where we will store the application number from the backend.  This number auto-increments
 * each time we cut a release
 */
type AppVersionState = AppState['appVersion'];
const appVersionReducer = (
    state: AppVersionState | null | undefined = null,
    action: AppAction
): AppVersionState => {
    switch (action.type) {
        case ActionTypes.APP_SET_APP_VERSION:
            return action.payload;
        default:
            return state;
    }
};

export type AppState = {
    apiVersion: string | null | undefined;
    appVersion: string | null | undefined;
};

export const reducer = combineReducers({
    apiVersion: apiVersionReducer,
    appVersion: appVersionReducer,
});
